// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3Ohsz","row":"styles_row__2rbYY"};